import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, useRef, useState } from "react";
import Icon from "../../../../../base/icons/icon/index.js";
import PersonCounterSelect from "../../components/person-counter-select/index.js";
import usePersonCounter from "../../hooks/usePersonCounter.js";
import * as S from "./styled.js";
const MobilePersonCounter = (props)=>{
    const { label ='' , description ='' , info , tooltip , max =0 , min =0 , onChange , select ={} , selectedOptions =[] , value =0 , disableIncrement =false , labelForEachOption =''  } = props;
    const { hasOptions , selectedValues  } = usePersonCounter(props);
    const hoverIconRef = useRef(null);
    const [hoverIcon, setHoverIcon] = useState(false);
    if ((!value && value !== 0) ?? !onChange) return null;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": "PersonCounter",
        className: "person-counter-wrapper",
        children: [
            /*#__PURE__*/ _jsxs(S.CounterContent, {
                children: [
                    /*#__PURE__*/ _jsxs(S.Title, {
                        children: [
                            /*#__PURE__*/ _jsxs(S.ContentLabel, {
                                children: [
                                    /*#__PURE__*/ _jsxs(S.Label, {
                                        children: [
                                            label,
                                            description && /*#__PURE__*/ _jsx("span", {
                                                children: description
                                            })
                                        ]
                                    }),
                                    info ? /*#__PURE__*/ _jsx(S.Info, {
                                        children: info
                                    }) : ''
                                ]
                            }),
                            tooltip && /*#__PURE__*/ _jsxs(S.IconWrapper, {
                                onMouseOver: ()=>setHoverIcon(true),
                                onMouseOut: ()=>setHoverIcon(false),
                                ref: hoverIconRef,
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        className: `nico-info`
                                    }),
                                    hoverIcon && /*#__PURE__*/ _jsx(S.TooltipStyled, {
                                        isNegative: false,
                                        referenceElement: hoverIconRef.current,
                                        placement: "bottom",
                                        options: {
                                            placement: 'bottom'
                                        },
                                        children: tooltip
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(S.CounterButtons, {
                        min: min,
                        max: max,
                        value: value,
                        disableIncrement: disableIncrement,
                        onChange: onChange
                    }, value)
                ]
            }),
            hasOptions && /*#__PURE__*/ _jsxs("div", {
                "data-testid": "PersonCounterOptions",
                children: [
                    select?.label && /*#__PURE__*/ _jsx(S.OptionsTitle, {
                        tag: "p",
                        content: select?.label
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: Children.toArray(selectedOptions?.map((_, selectedOptionIndex)=>/*#__PURE__*/ _jsx(PersonCounterSelect, {
                                selectedOptionIndex: selectedOptionIndex,
                                value: selectedValues[selectedOptionIndex],
                                options: select?.options,
                                onChange: select?.onChange,
                                ageLabel: labelForEachOption
                            })))
                    })
                ]
            })
        ]
    });
};
export default MobilePersonCounter;

//# sourceMappingURL=index.js.map